import React, { useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import "./style.css";

interface Props {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const OrganizationDescription: React.FC<Props> = ({
  formData,
  setFormData,
}) => {
  return (
    <div className="p-4" style={{ color: "#353535" }}>
      <Row>
        <Col xl={4} lg={6}>
          <Form.Group>
            <Row>
              <Col sm={4}>
                <Form.Label>Contact Surname</Form.Label>
              </Col>
              <Col sm={8}>
                <p className="contact-information-value">
                  {
                    formData.OrganizationDescription.Contact_Surname__c || "--"
                  }
                </p>
              </Col>
            </Row>
          </Form.Group>
          <Form.Group>
            <Row className="align-items-center">
              <Col sm={4}>
                <Form.Label>Contact First Name</Form.Label>
              </Col>
              <Col sm={8}>
                <p className="contact-information-value">
                  {
                    formData.OrganizationDescription.Contact_First_Name__c || "--"
                  }
                </p>
              </Col>
            </Row>
          </Form.Group>
          <Form.Group>
            <Row className="align-items-center">
              <Col sm={4}>
                <Form.Label>Street Address</Form.Label>
              </Col>
              <Col sm={8}>
                <p className="contact-information-value">
                  {
                    formData.OrganizationDescription.Street_Address__c || "--"
                  }
                </p>
              </Col>
            </Row>
          </Form.Group>
        </Col>
        <Col xl={4} lg={6}>
          <Form.Group>
            <Row
              className="align-items-center"
              style={{ marginBottom: "16px" }}
            >
              <Col sm={4}>
                <Form.Label>Phone/Cell</Form.Label>
              </Col>
              <Col sm={8}>
                <p className="contact-information-value">
                  {
                    formData.OrganizationDescription.Phone_Cell__c || "--"
                  }
                </p>
              </Col>
            </Row>
          </Form.Group>
          <Form.Group>
            <Row
              className="align-items-center"
              style={{ marginBottom: "16px" }}
            >
              <Col sm={4}>
                <Form.Label>Email</Form.Label>
              </Col>
              <Col sm={8}>
                <p className="contact-information-value">
                  {formData.OrganizationDescription.Email__c || "--"}
                </p>
              </Col>
            </Row>
          </Form.Group>
          <Form.Group>
            <Row className="align-items-center">
              <Col sm={4}>
                <Form.Label>Website</Form.Label>
              </Col>
              <Col sm={8}>
                <p className="contact-information-value">
                  {
                    formData.OrganizationDescription.Website__c || "--"
                  }
                </p>
              </Col>
            </Row>
          </Form.Group>
        </Col>
        <Col
          xl={4}
          lg={12}
          className="d-flex flex-column justify-content-between"
        >
          <Form.Group>
            <Row>
              <Col sm={4}>
                <Form.Label>Status</Form.Label>
              </Col>
              <Col sm={8}>
                <p className="contact-information-value">
                  {
                    formData.OrganizationDescription.Status__c || "--"
                  }
                </p>
              </Col>
            </Row>
          </Form.Group>
          <Form.Group>
            <Row>
              <Col sm={12}>
                <div>
                  <Form.Label>General Description of Organization</Form.Label>
                  <p style={{ fontSize: "12px" }}>
                    {
                      formData.OrganizationDescription.General_Description__c || "--"
                    }
                  </p>
                </div>
              </Col>
            </Row>
          </Form.Group>
        </Col>
      </Row>
      <Form.Group>
        <Row>
          <Col sm={12}>
            {/* <div className="d-flex">
              <Form.Label className="me-5">
                Total Number of Sites Included in the Certificate (excluding
                outsourcers)
              </Form.Label>
              <p className="contact-information-value">
                {
                  formData.OrganizationDescription.Allowable_Size_Limit__c || "0"
                }
              </p>
            </div> */}
          </Col>
        </Row>
      </Form.Group>
    </div>
  );
};

export default OrganizationDescription;
